import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import '../../../scss/components/_fullScreen.scss';
import API_PATH from "../../../constants/config.json";
import Cookies from 'js-cookie';
import {getMidblockStationRecentYear,getMidblockSummaryData,getMidblockADTeChart} from '../../../components_v2/Information/MidblockGetData';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { loadModules } from 'esri-loader';

import VolumeChart from '../../StationDetails/Midblock/VolumeChart';
import SpeedChart from '../../StationDetails/Midblock/SpeedChart';
import ClassificationChart from '../../StationDetails/Midblock/ClassificationChart';
import FileList from '../../StationDetails/FileList';
import NoDetails from '../../StationDetails/NoDetails';

import StationCard from '../../StationDetails/Midblock/StationCard';
import SummaryCard from '../../StationDetails/Midblock/SummaryCard';
import ChartCard from '../../StationDetails/Midblock/ChartCard';
import DetailsCard from '../../StationDetails/Midblock/DetailsCard';
import ExportData from '../../../components_v2/DataFilter/ExportData';

import SummaryVolume from '../../StationDetails/Midblock/SummaryVolume';
import SummarySpeed from '../../StationDetails/Midblock/SummarySpeed';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import HomeIcon from '@material-ui/icons/Home';


import Button from '@material-ui/core/Button';
import ExportDataDetails from '../ExportDataDetails';
import HelpDisk from '../../Information/HelpDisk';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const queryString = require('query-string');
let _intersectionChecked
let _midblockChecked
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

const FullScreen = props => {
    let history = useHistory();
    let msWidth = window.innerHeight;
    if (window.screen.width >= 100 && window.screen.width <= 1500) {
        msWidth = window.innerWidth;
      }
      else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
        msWidth = window.innerWidth;
      }
      else if (window.screen.width >= 3501) {
        msWidth = window.innerWidth;
      }
      else {
        msWidth = window.innerWidth;
      }
      
      React.useEffect(
        () => {     
          if (props.location) {
            const parsed = queryString.parse(props.location.search);            
            if (parsed && parsed.station) {    
              let sharedAgency = (parsed.by)?parsed.by : false;               
              getStationId(parsed.station,sharedAgency);                          
            } else {
                window.location.href = '/UsersDashboard';
            }
          }          
        }, []
    );  

    
    const mapRef = useRef();
    const [stationData, setStationData] = React.useState(null);
    const [stationID, setStationID] = React.useState(null);
    const [hasData, setHasData] = React.useState(false);

    const [volumeCountDate, setVolumeCountDate] = React.useState(null);
    const [volumeClassCountDate, setVolumeClassCountDate] = React.useState(null);
    const [traffiSpeedCountDate, setTraffiSpeedCountDate] = React.useState(null);

    const [yearList, setYearList] = React.useState([]);
    const [getADTSummery, setADTSummery] = React.useState([]);
    const [getTruckPercent, setTruckPercent] = React.useState([]);
    const [getADTGrowthFactor, setADTGrowthFactor] = React.useState([]);
    const [getDFactor, setDFactor] = React.useState([]);
    const [getKFactor, setKFactor] = React.useState([]);
    const [getPeakHr, setPeakHr] = React.useState([]);
    const [getPeakDir, setPeakDir] = React.useState([]);
    const [getLOS, setLOS] = React.useState([]);
   
    const [eChartYear, setEChartYear] = React.useState([]);
    const [eChartTrendLineData, setEChartTrendLineData] = React.useState([]);
    const [eChartGet, setEChartGet] = React.useState([]);
    const [getchart, setchart] = React.useState([]);

    const [midBlockScreenWidth, setMidBlockScreenWidth] = React.useState(msWidth);
    const [stationList, setStationList] = React.useState([]);    
    const [totalItems, setTotalItems] = React.useState(0);
    const [userAccess, setUserAccess] = React.useState(true);    
    const [getLoader, setLoaderDisable] = React.useState(false);
    let enteriesPerPage = 50;

    const [openAllDetails, setOpenAllDetails] = React.useState(false);    
    const handleCloseAllDetails = () => setOpenAllDetails(false);
    const [tabValue, setTabValue] = React.useState(0);

    const [tabValueDataType, setTabValueDataType] = React.useState(0);
    const handleChangeTabDataType = (event, newValue) => {      
        setTabValueDataType(newValue);
    };
  
    const [getResponseData, setResponseData] = React.useState([]);
    const [dateArr, setDateArr] = React.useState([]);
    const [dateVal, setDateVal] = React.useState([]);
    const [selectedDate, setSelectedDate] = React.useState([]);
    const [dataType, setDataType] = React.useState('Volume');
  
    const [getData, setData] = React.useState({});
    const [getCombinedData, setCombinedData] = React.useState([{ amPeakHour: 0, amPeakVolume: 0 }, { pmPeakHour: 0, pmPeakVolume: 0 }]);
    const [getNBData, setNBData] = React.useState([{ amPeakHour: 0, amPeakVolume: 0 }, { pmPeakHour: 0, pmPeakVolume: 0 }]);
    const [getSBData, setSBData] = React.useState([{ amPeakHour: 0, amPeakVolume: 0 }, { pmPeakHour: 0, pmPeakVolume: 0 }]);
  
    const [getSpeedData, setSpeedData] = React.useState([]);
    const [getDirectionSpeedName, setDirectionSpeedName] = React.useState('');
    const [getDirectionSpeedCombine, setDirectionSpeedcombine] = React.useState('');
    const [getDirectionSpeedNameTab, setDirectionSpeedNameTab] = React.useState('');
  
    const [getClassData, setClassData] = React.useState();
    const [getDirectionClassCombine, setDirectionClasscombine] = React.useState('');
    const [getDirectionClassName, setDirectionClassName] = React.useState('');
    const [getDirectionClassNameTab, setDirectionClassNameTab] = React.useState('');
    
    const [getDirectionName, setDirectionName] = React.useState('NB');
    const [getDirectionNameTab, setDirectionNameTab] = React.useState('SB');
  
    const [volumeHasData, setVolumeHasData] = React.useState(false);
    const [speedHasData, setSpeedHasData] = React.useState(false);
    const [classHasData, setClassHasData] = React.useState(false);

    const [myOptions, setmyOptions] = React.useState({});

    const [exportChecked, setExportChecked] = React.useState('none');
    const [midblockChecked, setMidblockChecked] = React.useState(false);
    const [intersectionChecked, setIntersectionChecked] = React.useState(false);
    const [multipleStationId, setMutipleStationId] = React.useState([]);
    const [singleMidblockStationId, setSingleMidblockStationId] = React.useState([]);
    const [singleIntersectionStationId, setSingleIntersectionStationId] = React.useState([]);

    const [sharedStation,setSharedStation] = React.useState(false);
    const [sharedAgencyName,setSharedAgencyName] = React.useState(false);
    const [zoom, setZoom] = React.useState(null);
    const getStationId = (id,agency=false) => {
        try {
          axios({
            method: 'post',
            data: {
              "clientStationId": id,
              "sharedby":agency
            },
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.getStationId
          }).then(function (response) {
            if (response && response.data && response.data.data && response.data.data.length > 0) {
              const stationId = response.data.data[0].station_id;
              setStationID(stationId);
              getStationDetail(stationId)
            } else {
              window.location.href = '/UsersDashboard';
            }
          })
        }
        catch (error) {
          // Throw the error
        }
    }

    const exportpopUp = () => {
    
      if (exportChecked == 'none') {
        setExportChecked('block');
      }
      else {
        setExportChecked('none');
        //setMutipleStationId([]);
      }
    }
    const getStationDetail = (station_id) => {          
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getStationDetail + station_id,
            }).then(async function (response) {  
                let data = response.data.data; 
                setStationData(data) 

                //review shared
                let shared = (data.is_shared && data.FK_agency_id != sessionStorage.getItem('agency_id'))?true : false;
                let sharedBy = (shared)?data.agency : '';
                setSharedStation(shared);
                setSharedAgencyName(sharedBy);
                //

                let midblockStationRecentYear = await getMidblockStationRecentYear(station_id);            
                let midblockHasData = (midblockStationRecentYear.length !=0 && (midblockStationRecentYear.volumeyear!='' || midblockStationRecentYear.classyear!='' || midblockStationRecentYear.speedyear!=''))?true:false;
                if(midblockHasData){              
                    let midblockSummaryData = await getMidblockSummaryData(station_id);
                    let midblockADTeChart = await getMidblockADTeChart(station_id);

                    setVolumeCountDate(midblockStationRecentYear.hasOwnProperty('volumeyear')?midblockStationRecentYear.volumeyear:null);
                    setVolumeClassCountDate(midblockStationRecentYear.hasOwnProperty('classyear')?midblockStationRecentYear.classyear:null);
                    setTraffiSpeedCountDate(midblockStationRecentYear.hasOwnProperty('speedyear')?midblockStationRecentYear.speedyear:null);

                    setYearList(midblockSummaryData[0]?midblockSummaryData[0].adt:[]);
                    setADTSummery(midblockSummaryData[0]?midblockSummaryData[0].adt:[]);
                    setTruckPercent(midblockSummaryData[1]?midblockSummaryData[1].truckpercent:[]);
                    setADTGrowthFactor(midblockSummaryData[2]?midblockSummaryData[2].growthrate:[]);
                    setDFactor(midblockSummaryData[3]?midblockSummaryData[3].d_factor:[]);
                    setKFactor(midblockSummaryData[4]?midblockSummaryData[4].k_factor:[]);
                    setPeakHr(midblockSummaryData[5]?midblockSummaryData[5].peak_hour:[]);
                    setPeakDir(midblockSummaryData[6]?midblockSummaryData[6].peak_dir:[]);
                    setLOS(midblockSummaryData[7]?midblockSummaryData[7].los:[]);

                    let eChartYear = midblockADTeChart.hasOwnProperty('eChartYear')?midblockADTeChart.eChartYear:[];
                    let eChartData = midblockADTeChart.hasOwnProperty('eChartData')?midblockADTeChart.eChartData:[];
                    let eChartTrendLineData = midblockADTeChart.hasOwnProperty('eChartTrendLineData')?midblockADTeChart.eChartTrendLineData:[]
                    let eChartGet = midblockADTeChart.hasOwnProperty('eChartGet')?midblockADTeChart.eChartGet:0;
                    let etchart = midblockADTeChart.hasOwnProperty('etchart')?midblockADTeChart.etchart:[];

                    setEChartYear(eChartYear);
                    setEChartTrendLineData(eChartTrendLineData);
                    setEChartGet(eChartGet);
                    setchart(etchart); 
                    myOptionFunction(eChartYear,eChartTrendLineData,etchart);
   
                }
                setTabValue(0);
                loadMap(data,midblockHasData,shared);
                getFileList(station_id); 
                getDateList(station_id);
                setHasData(midblockHasData);
                                     
            })
            .catch(function (error) {
                console.log(error);
            })
        } catch (error) {
          console.error(error);
        }
    }

    const handleChangeTab = (event, newValue) => {
        if(newValue == 0){
          loadMap();
        }
        setTabValue(newValue);
    };
    
    
        const myOptionFunction = (myeChartYear=null,myeChartTrendLineData=null,myetchart=null) =>{
            // console.log(myeChartYear,myeChartTrendLineData,myetchart);
            let opteChartYear = (myeChartYear !=null)?myeChartYear : eChartYear;
            let opteChartTrendLineData = (myeChartTrendLineData != null)?myeChartTrendLineData : eChartTrendLineData;
            let optetchart = (myetchart != null)?myetchart : getchart;

            let tmpCountYear = myeChartYear.length >= 2 ? myeChartYear[myeChartYear.length-1] - myeChartYear[0] : 0;

            setmyOptions(
                {
                    color: ["#71717A"],
                    title: {
                      text: null
                    },
                    grid: {          
                      bottom: '35px',
                      top: '20px',          
                      left:'35px',
                      right: '25px'
                    },
                    tooltip: {
                      trigger: 'item',    
                      formatter: (params, index) => {
                        let res = '';
                        let colorCumulative = ['#696969', '#428adc'];
                        var colorSpan = (color) => '<span style="display:inline-block;margin-right:5px;margin-top:5px;border-radius:10px;width:9px;height:9px;float:left;background-color:' + color + '"></span>';
                        if ((params.componentType == "series") && (params.componentSubType == 'line')) {
                          res += '<span style="float:left">' + parseFloat(params.data[0]) + '</span>' +
                            ' <br/>' + colorSpan(colorCumulative[1]) + '<span style="float:left">' + params.data[2] + '</span>';
                        }
                        return res;
                      }
                
                    },
                    legend: {
                      data: []
                    },
                    xAxis: [{
                      type: "value",
                      interval: 1,
                      min: (opteChartYear.length > 1 ? Math.min(...opteChartYear) : (opteChartYear[0]) - 1),
                      max: (opteChartYear.length > 1 ? Math.max(...opteChartYear) : (opteChartYear[0]) + 1),
                      splitLine: {
                        show: true,
                        lineStyle: {              
                          color: '#F4F4F5',              
                          width: 1
                        }
                      },
                      axisLine : {
                        show : false
                      },
                      axisTick : {
                        show : false
                      },
                      axisLabel: {
                        rotate: tmpCountYear > 10 ? 45 : 0,         
                        fontSize: 8,            
                        formatter: function (value, index) {
                          return parseInt(value.toString().replace(",", ""));
                        }
                      },
                
                    }],
                    yAxis: {
                      type: 'value',
                      splitLine: {
                        show: true,
                        lineStyle: {              
                          color: '#F4F4F5',              
                          width: 1
                        }
                      },
                      axisLine : {
                        show : false
                      },
                      axisTick : {
                        show : false
                      },
                      axisLabel: {            
                        fontSize: 8,            
                      },
                      scale: true
                    },
                    series: [
                      {
                        name: 'Volume Growth',
                        type: 'line',
                        symbolSize: 6,
                        color: "#2563EB",
                        colorAlpha: "#2563EB",
                        data: optetchart,
                        lineStyle: {
                          type: 'solid',
                          color: "#2563EB",
                          width: 2
                        },
                      },
                      {
                        type: 'line',
                        data: opteChartTrendLineData,
                        symbol: 'none',
                        lineStyle: {
                          type: 'dashed',
                          color: "#7e9ed6",
                          width: 2
                        },
                        label: {
                          show: false
                        },
                      }
                    ]
                  }
            )
        }
        const getDateList = (station_id=null) => {
            let id = (station_id!=null)?station_id : stationID;
          setLoaderDisable(true);
          try {
              axios({
                  method: 'post',
                  data: {
                      "stationId": id
                  },
                  headers: {
                      'payload': Cookies.get('payload'),
                      'agencyid': sessionStorage.getItem('agency_id')
                  },
                  url: API_URL + API_PATH.getStationMBCountDateList
              }).then(async function (response) {
                  if (response && response.data.data && response.data.data.length > 0) {
                      setLoaderDisable(false);
                      let tempArr = [];
                      let tempDateArr = [];
                      setResponseData(response.data.data);
                      response.data.data.map((val) => {
                          tempDateArr.push(val.send_date);
                          tempArr.push(val.date_count);
                      });
                      if(sessionStorage.getItem('midSelectedDate')) {
                          getAllVolumeData(sessionStorage.getItem('midSelectedDate'), response.data.data);
                          getAllSpeedData(sessionStorage.getItem('midSelectedDate'));
                          setSelectedDate(sessionStorage.getItem('midSelectedDate'))
                          getClassificationData(sessionStorage.getItem('midSelectedDate'));
                      } else {
                          setSelectedDate(tempDateArr[0]);                        
                          let reviewvolume = await getAllVolumeData(tempDateArr[0], response.data.data,id);
                          let reviwspeed = await getAllSpeedData(tempDateArr[0],id);                        
                          let reviewclass = await getClassificationData(tempDateArr[0],id); 
                          
                          reviewData(reviewvolume,reviwspeed,reviewclass);
                      }                  
                      setDateVal(tempDateArr);
                      setDateArr(tempArr);
                  } else {
                      console.log("");
                      setLoaderDisable(false);
                  }
              })
          }
          catch (error) {
              setLoaderDisable(false);           
          }
      }  
      const reviewData = (volume,speed,classd) =>{
        let volumeHasData = (Object.keys(volume).length>0)? true : false;
        let speedHasData = (Object.keys(speed).length>0)? true : false;
        let classHasData = (Object.keys(classd).length>0)? true : false;
        let tmpDataType = null;
        if( (tmpDataType == null || dataType === "Volume" ) && volumeHasData){
          tmpDataType = 'Volume';
        }
        if( (tmpDataType == null || dataType === "Classification" ) && classHasData){
          tmpDataType = 'Classification'
        }
        if( (tmpDataType == null || dataType === "Speed" ) && speedHasData){
          tmpDataType = 'Speed'
        }         
        setDataType(tmpDataType); 

        setVolumeHasData(volumeHasData);
        setSpeedHasData(speedHasData);
        setClassHasData(classHasData);
      }
        const loadMap = (data = null,hasDataInfo=null,shared=null) => {
            hasDataInfo = (hasDataInfo !=null)?hasDataInfo : hasData; 
          // lazy load the required ArcGIS API for JavaScript modules and CSS
          loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search"], { css: true })
            .then(async ([ArcGISMap, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search]) => {
              const map = new ArcGISMap({
                basemap: (sessionStorage.getItem('baseMapType') !=null && sessionStorage.getItem('baseMapType') =='hybrid')?'hybrid':'streets-navigation-vector',
                slider: false
              });        
              let view = new MapView({
                container: mapRef.current,
                map: map,
                ui: {
                  components: ['home', 'locate'] // specify only the components you want
                },
              });
              let zoom = new Zoom({
                view: view,
              });
              let featureLayer = new FeatureLayer({
                url: sessionStorage.getItem('mapURL')
              });
              featureLayer.when(function () { // adds feature layer to map view
                let vp = new Viewpoint({
                  targetGeometry: featureLayer.fullExtent
                });
                view.extent = featureLayer.fullExtent;
      
              });
              setZoom(zoom);
              map.add(featureLayer);
              //let position = await getStationDetails();
              let lng = (data != null)?data.longitude : stationData.longitude;
              let lat = (data != null)?data.latitude : stationData.latitude;
              shared = (shared != null)?shared : sharedStation;
              featureLayer.when(async function () { // adds feature layer to map view         
                // console.log('Logn :'+longitude+ 'Lat :'+latitude);          
                let point = new Point(lng, lat);          
                let pointSymbol = {
                  type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                  url: shared?require("../../../assets/icons/marker_Midblock_shared.png"):require("../../../assets/icons/marker_Midblock.png"),
                  width: "34px",
                  height: "34px",
                  yoffset: "20px"
                }
                let pointGraphic = new Graphic(point, pointSymbol);
                view.graphics.add(pointGraphic);
                view.goTo(pointGraphic).then(function () {
                  view.zoom = view.zoom + 5;
                  if(!hasDataInfo){
                    //view.graphics.remove(pointGraphic);
                  }
                });
              });
      
            });
          }    
          const getFileList = (station_id=null) => { // API call to get all files
            let id = (station_id !=null)?station_id:stationID;
            setLoaderDisable(true);
            try {
              axios({
                method: 'post',
                data: {
                  stationId: id,
                  pageNo: 1,
                  entriesPerPage: enteriesPerPage
                },
                headers: {
                  'payload': Cookies.get('payload'),
                  'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.fileList,
              })
                .then(async function (response) {                
                  if (response.status && response.status == '200') {
                    setLoaderDisable(false);
                    setStationList(response.data.data.rows);
                    setTotalItems(response.data.data.count);
                  } else {
                    setStationList([]);
                    setLoaderDisable(false);
                  }
                })
                .catch(function (error) {
                  if (error.response) {
                    if (error.response.data.status == 403) {
                      setUserAccess(false);
                      setLoaderDisable(false);
                      setStationList([]);
                    } else {
                      setStationList([]);
                      setLoaderDisable(false);
                    }
                  } else {
                    setStationList([]);
                    setLoaderDisable(false);
                  }
                })
            } catch (error) {
              console.error(error);
              setLoaderDisable(false);
            }
          }      
      const getAllVolumeData = async (date = null, data,station_id=null) => {
        let id = (station_id!=null)?station_id:stationID;
        setLoaderDisable(true);
            try {
                return axios({
                    method: 'post',
                    data: {
                        "stationId": id,
                        "dateData": date ? date : selectedDate,
                    },
                    headers: {
                        'payload': Cookies.get('payload'),
                        'agencyid': sessionStorage.getItem('agency_id')
                    },
                    url: API_URL + API_PATH.getstationMBDetail,
                })
                    .then(async function (response) {
                        if (response.status && response.status == '200') {
                            setLoaderDisable(false);
                            let resData = data.filter((value, index) => {
                                return value.send_date == date;
                            })                          
                            //disableTab(resData[0]);
                            setData(response.data.data);
                            setCombinedData(response.data.data.dir12.peak);
                            setNBData(response.data.data.dir1.peak);                          
                            setSBData(response.data.data.dir2.peak);
                            setDirectionNameTab(response.data.data.dir2.direction)
                            setDirectionName(response.data.data.dir1.direction)
  
                            return response.data.data;
                        } else {
                            setLoaderDisable(false);
                            setCombinedData([]);
                            setNBData([]);
                            setSBData([]);
                            setData([]);
                            return [];
                        }
                    })
                    .catch(function (error) {
                        setLoaderDisable(false);
                        setCombinedData([]);
                        setNBData([]);
                        setSBData([]);
                        setData([]);
                        return [];
                    })
            } catch (error) {
                setLoaderDisable(false);
                setCombinedData([]);
                setNBData([]);
                setSBData([]);
                setData([]);
                return [];
            }
        }
        const getAllSpeedData = async (date = null,station_id=null) => {
        let id = (station_id!=null)?station_id:stationID;
          setLoaderDisable(true);
              try {
                  return axios({
                      method: 'post',
                      data: {
                          "stationId": id,
                          "dateData": date ? date : selectedDate,
                          "isKph": await sessionStorage.getItem("isKph").toString() === "true" ? true : false
                      },
                      headers: {
                          'payload': Cookies.get('payload'),
                          'agencyid': sessionStorage.getItem('agency_id')
                      },
                      url: API_URL + API_PATH.getstationMBSpeedDetail,
                  })
                      .then(async function (response) {
                          if (response.status && response.status == '200') {
                              setLoaderDisable(false);
                              setSpeedData(response.data.data)
                              setDirectionSpeedName(response.data.data.data1.dir1);
                              setDirectionSpeedcombine(response.data.data.combine.dir12);
                              setDirectionSpeedNameTab(response.data.data.data2.dir2);
  
                              return response.data.data;
      
                          } else {
                              setLoaderDisable(false);
                              setSpeedData([]);
  
                              return [];
                          }
                      })
                      .catch(function (error) {
                          setLoaderDisable(false);     
                          return [];                     
                      })
              } catch (error) {
                  setLoaderDisable(false);
                  console.error(error);
                  return [];
              }
          }
          const getClassificationData = async (date = null,station_id=null) => {
            let id = (station_id!=null)?station_id:stationID;
            setLoaderDisable(true);
            try {
                return axios({
                    method: 'post',
                    data: {
                      "stationId": id,
                      "dateData": date ? date : selectedDate,
                    },
                    headers: {
                        'payload': Cookies.get('payload'),
                        'agencyid': sessionStorage.getItem('agency_id')
                    },
                    url: API_URL + API_PATH.getstationMBClassificationDetail,
    
                }).then(function (response) {
                    if (response && response.data.data) {
                        setLoaderDisable(false);
                        setClassData(response.data.data)                      
                        setDirectionClasscombine(response.data.data.combine.dir12)
                        setDirectionClassName(response.data.data.data1.dir1)
                        setDirectionClassNameTab(response.data.data.data2.dir2)
  
                        return response.data.data;
                    } else {
                        setLoaderDisable(false);
                        setClassData([]);                      
                        return [];
                    }                
                }).catch((err) => {
                    setLoaderDisable(false);
                    setClassData([]);                  
                    return [];
                })
            }
            catch (error) {
                setLoaderDisable(false);
                return [];
            }
        }      
        const dateChange = async (e) => {
            //sessionStorage.setItem('midSelectedDate',e.target.value);
            setSelectedDate(e.target.value);          
  
            let reviewvolume = await  getAllVolumeData(e.target.value, getResponseData);
            let reviwspeed = await  getAllSpeedData(e.target.value);                       
            let reviewclass = await getClassificationData(e.target.value);
            
            reviewData(reviewvolume,reviwspeed,reviewclass);
        } 
        const dataTypeChange = (e) => {        
          setDataType(e.target.value);
          //getAllVolumeData(e.target.value, getResponseData);
          //getAllSpeedData(e.target.value);
      }
      const setExportData = () => {
        console.log("export data",stationData)
        setSingleMidblockStationId([{ station_id: stationData.station_id,
                     station_type: stationData.station_type, 
                     client_Station_Id: stationData.client_station_id, 
                     Station_location: stationData.station_location }]);
        
        exportpopUp();
        
      }
      const homeEvent = () => { // event to go at initial view
    
      }
      const ZoomInEvent = () => { // event to zoom in map
        zoom.zoomIn();
    
      }
      const zoomOutEvent = () => { // event to zoom out map
        zoom.zoomOut();
      }

    return (
        <div className='full-screen-main'>
            <div className='md-all-details'>
             <div className='md-header-details'>
              <Tabs value={tabValue} onChange={handleChangeTab} className='tb-hd-main-opts' aria-label="basic tabs example">
                <Tab label="Station details" {...a11yProps(0)} />
                <Tab label="Traffic counts" {...a11yProps(1)} disabled={!hasData} />              
              </Tabs>  
              <div className='header-options-md'>
                <Button 
                    className='btn-blue btn-export-data' 
                    variant="contained" 
                    disabled={!hasData}
                    style={!hasData?{opacity:'0.5'}:{}}
                    onClick={setExportData}><img src={require('../../../assets/icons/File - Download.svg')} style={{marginRight:'10px'}}/> 
                    Export
                </Button>
              </div>        
             </div>
             <div className='md-body-details'> 
             {sharedStation?<div className='tb-shared-info-mn'><Card className='tb-details-info tb-shared-info' style={{}}> 
                  <img src={require('../../../assets/icons/shared_icon.svg')}/>
                  <div className="tb-shared-info-lb">
                      <span>Shared</span>
                      <label>This station is shared from {sharedAgencyName}</label>
                  </div> 
                </Card></div>:null}
              <TabPanel value={tabValue} index={0}>
              <div className='details-summary-map-files'> 
                  <div className='details-summary-map'>
                    <div className='details-summary'>
                      <div className='details-card'> 
                        <label className='info-sub-title'>Station</label>
                        {stationData?<StationCard clss={!hasData?'details-main-info details-main-no-data':'details-main-info'} sharedStation={sharedStation} sharedAgencyName={sharedAgencyName} stationData={stationData} volumeCountDate={volumeCountDate} volumeClassCountDate={volumeClassCountDate} traffiSpeedCountDate={traffiSpeedCountDate}/>:null}
                      </div>
                      {(yearList.length>0)?<div className='details-card'>
                      <label className='info-sub-title'>Summary</label>
                        <SummaryCard 
                          yearList={yearList} 
                          getADTSummery={getADTSummery}
                          getTruckPercent={getTruckPercent}
                          getADTGrowthFactor={getADTGrowthFactor}
                          getDFactor={getDFactor}
                          getKFactor={getKFactor}
                          getPeakDir={getPeakDir}
                          getPeakHr={getPeakHr}
                          getLOS={getLOS}
                        />
                      </div>:null}
                      {(!hasData)?<NoDetails stationData={stationData}/>:null}
                      {(hasData)?<div className='details-card'>
                        <label className='info-sub-title'>Details</label>
                        <DetailsCard stationData={stationData}/> 
                      </div>:null}
                      {(hasData && stationData.miscellaneous && yearList.length>1)?
                        <div className='details-card' style={{marginTop: '16px'}}>
                          <label className='info-sub-title'>Miscellaneous</label>
                          <Card className='info-details-miscellaneous'>
                            {stationData.miscellaneous}
                          </Card>
                        </div>
                      :null}
                    </div>
                    <div className='details-map'>
                      <label>Map</label> 
                      <div className='details-map-cnt'> 
                        {/*!hasData?<div className='disabled-map' style={{height: '90%'}}></div>:null*/}
                        <div ref={mapRef} className={!hasData?'map-details-pn map-details-no-data':'map-details-pn'} data-testid='mapView' style={!hasData?{opacity:'1'}:{}}></div>
                        <Box display='flex' flexDirection="column" className="homeIconList" style={!hasData?{opacity:'1'}:{}}>
                          {/* <div data-testid="homeBtn" className="homeIcon" title="Home">
                            <HomeIcon onClick={() => homeEvent()} title="Home" />
                          </div>                         */}
                          <div data-testid="zoomInBtn" className="zoomIcon" style={{ marginBottom: '-3px' }} title="Zoom In">
                            <AddIcon onClick={() => ZoomInEvent()} title="Zoom In" />
                          </div>
                          <div data-testid="zoomOutBtn" className="inIcon" title="Zoom Out">
                            <RemoveIcon onClick={() => zoomOutEvent()} title="Zoom Out" />
                          </div>
                        </Box> 
                      </div>                      
                      {(yearList.length>1)?<div className='details-card' style={{marginTop:'16px', width: '576px'}}>
                        <label className='info-sub-title'>ADT by year</label>
                        <ChartCard eChartGet={eChartGet} myOptions={myOptions}/>
                      </div>:null}
                      {(hasData && stationData.miscellaneous && yearList.length<=1)?
                        <div className='details-card' style={{marginTop: '16px', width: '376px'}}>
                          <label className='info-sub-title'>Miscellaneous</label>
                          <Card className='info-details-miscellaneous'>
                            {stationData.miscellaneous}
                          </Card>
                        </div>
                      :null}
                    </div>                                      
                  </div>
                  <div className='tb-list-files-act'>
                      <Card className='card-file-list'>
                        <FileList list={stationList} getFileList={getFileList} fullscreen={true} stationData={stationData} sharedStation={sharedStation}/> 
                      </Card>
                  </div>
                </div>   
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
              <div className='details-traffic-count'>
                <div className='tc-card'>
                    <label>Station</label>
                    <div className='md-body-card-details'>
                      <StationCard sharedStation={sharedStation} sharedAgencyName={sharedAgencyName} stationData={stationData} volumeCountDate={volumeCountDate} volumeClassCountDate={volumeClassCountDate} traffiSpeedCountDate={traffiSpeedCountDate}/>
                    </div>
                </div>
                <div className='tc-card' style={{margin:'0px 16px'}}>
                    <label>Count date</label> 
                    <Card className='tb-details-info card-count-date-info' style={{width:'100%',padding:'25px 12px'}}>                    
                      <Select             
                          className="select-dp"                             
                          value={selectedDate} 
                          onChange={(e) => dateChange(e)}
                          height='38px'   
                          style={{width:'376px'}}   
                          IconComponent={ExpandMoreIcon} 
                          MenuProps={{PaperProps:{className:'slct-details-data-type'}}}                       
                      >
                        {dateArr && dateArr.length > 0 ?
                            dateArr.map((val, index) => {
                                return <MenuItem value={ dateVal[index] }>{val}</MenuItem>
                            })
                            :
                            <option value=''>{'No data available'}</option>
                        }                      
                      </Select>
                    </Card>
                </div>
                <div className='tc-card'>
                  <label>Data type</label>
                  <Card className='tb-details-info card-data-type-info' style={{width:'100%',padding:'25px 12px'}}>
                    <Select             
                          className="select-dp"                             
                          value={dataType} 
                          onChange={(e) => dataTypeChange(e)}
                          height='38px'   
                          style={{width:'376px'}}   
                          IconComponent={ExpandMoreIcon}    
                          MenuProps={{PaperProps:{className:'slct-details-data-type'}}}                    
                      >
                        <MenuItem value={'Volume'} disabled={!volumeHasData}>Volume</MenuItem>
                        <MenuItem value={'Classification'} disabled={!classHasData}>Classification</MenuItem>
                        <MenuItem value={'Speed'} disabled={!speedHasData}>Speed</MenuItem>
                                            
                    </Select>
                  </Card> 
                </div>
              </div>
              <div className='details-tf-study'>                                          
                {dataType=='Volume'?<SummaryVolume
                  getCombinedData={getCombinedData}
                  getDirectionName={getDirectionName}
                  getDirectionNameTab={getDirectionNameTab}
                  getNBData={getNBData}
                  getSBData={getSBData}
                />:null}
                {dataType=='Speed'?<SummarySpeed
                  getSpeedData={getSpeedData}
                  getDirectionSpeedName={getDirectionSpeedName}
                  getDirectionSpeedNameTab={getDirectionSpeedNameTab}
                />:null}                
                <div className='data-chart-details'>
                  {dataType=='Volume'?<Tabs value={tabValueDataType} onChange={handleChangeTabDataType} className='tb-charts-directions' aria-label="basic tabs example">
                      {(getDirectionName!="" && getDirectionNameTab!="")?<Tab label="Combined" {...a11yProps(0)} />:null}
                      {getDirectionName!=""?<Tab label={getDirectionName} {...a11yProps(1)}  />:null}
                      {getDirectionNameTab!=""?<Tab label={getDirectionNameTab} {...a11yProps(2)}  />:null}                              
                    </Tabs>:null}
                    {dataType=='Speed'?<Tabs value={tabValueDataType} onChange={handleChangeTabDataType} className='tb-charts-directions' aria-label="basic tabs example">
                      {(getDirectionSpeedName!="" && getDirectionSpeedNameTab!="")?<Tab label="Combined" {...a11yProps(0)} />:null}
                      {getDirectionSpeedName!=""?<Tab label={getDirectionSpeedName} {...a11yProps(1)}  />:null}
                      {getDirectionSpeedNameTab!=""?<Tab label={getDirectionSpeedNameTab} {...a11yProps(2)}  />:null}                              
                    </Tabs>:null}  
                    {dataType=='Classification'?<Tabs value={tabValueDataType} onChange={handleChangeTabDataType} className='tb-charts-directions' aria-label="basic tabs example">
                      {(getDirectionClassName!="" && getDirectionClassNameTab!="")?<Tab label="Combined" {...a11yProps(0)} />:null}
                      {getDirectionClassName!=""?<Tab label={getDirectionClassName} {...a11yProps(1)}  />:null}
                      {getDirectionClassNameTab!=""?<Tab label={getDirectionClassNameTab} {...a11yProps(2)}  />:null}                              
                    </Tabs>:null}
                </div>
              </div>
              <div className='details-tf-study'>
                <div className='data-chart-details'>
                  {(dataType == 'Volume')?<>
                    <TabPanel value={tabValueDataType} index={0}>    
                      <div className='mb-chart-details-gd'>                                            
                        <VolumeChart data={getData.dir12}/>                          
                      </div>                   
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={1}>
                        <div className='mb-chart-details-gd'>                                              
                          <VolumeChart data={getData.dir1}/>                                   
                        </div>                            
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={2}>                            
                        <div className='mb-chart-details-gd'>                            
                          <VolumeChart data={getData.dir2}/>                              
                        </div>     
                    </TabPanel>
                  </>:null}
                  {(dataType == 'Speed')?<>      
                    <TabPanel value={tabValueDataType} index={0}>                       
                      <div className='mb-chart-details-gd'>
                        <SpeedChart data={getSpeedData.combine}/>          
                      </div>           
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={1}>    
                        <div className='mb-chart-details-gd'>
                          <SpeedChart data={getSpeedData.data1}/>         
                        </div>
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={2}>    
                        <div className='mb-chart-details-gd'>
                          <SpeedChart data={getSpeedData.data2}/>         
                        </div>
                    </TabPanel>
                  </>:null}

                  {(dataType == 'Classification')?<>      
                    <TabPanel value={tabValueDataType} index={0}>                       
                      <div className='mb-chart-details-gd'>
                        <ClassificationChart data={getClassData.combine}/>                     
                      </div>
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={1}>    
                        <div className='mb-chart-details-gd'>
                          <ClassificationChart data={getClassData.data1}/>         
                        </div>
                      </TabPanel>
                      <TabPanel value={tabValueDataType} index={2}>    
                        <div className='mb-chart-details-gd'>
                          <ClassificationChart data={getClassData.data2}/>         
                        </div>
                    </TabPanel>
                  </>:null}

                </div>
              </div>  
              </TabPanel>              
             </div>
           </div>
           {exportChecked == 'block' ?
              <div className="exportDataPanel" style={{ display: exportChecked }}>
                <ExportDataDetails 
                  checkExportValue={exportpopUp} 
                  groupStations={singleMidblockStationId} />
              </div>
              : null}
          <HelpDisk /> 
        </div>
    )
}

export default FullScreen;